var map = {
	"./ai-dark-en.mp4": 4678,
	"./ai-dark-ru.mp4": 9328,
	"./ai-light-en.mp4": 7606,
	"./ai-light-ru.mp4": 8048,
	"./buba-0.png": 5972,
	"./buba-1.png": 5965,
	"./buba-2.png": 8902,
	"./buba-3.png": 9367,
	"./buba-4.png": 3536,
	"./buba-5.png": 1561,
	"./buba-6.png": 4594,
	"./buba-c-0.png": 4216,
	"./buba-c-1.png": 8126,
	"./buba-c-10.png": 9491,
	"./buba-c-11.png": 6226,
	"./buba-c-2.png": 8186,
	"./buba-c-3.png": 6859,
	"./buba-c-4.png": 8524,
	"./buba-c-5.png": 9813,
	"./buba-c-6.png": 3902,
	"./buba-c-7.png": 3695,
	"./buba-c-8.png": 6704,
	"./buba-c-9.png": 2425,
	"./confirm-en.jpg": 1548,
	"./confirm-ios-en.jpg": 79,
	"./confirm-ios-ru.jpg": 8185,
	"./confirm-ru.jpg": 8889,
	"./home/ai-recolor-after.jpg": 1993,
	"./home/ai-recolor-before.jpg": 272,
	"./home/ai-recolor-choice-after.jpg": 8453,
	"./home/ai-recolor-choice-before.jpg": 4604,
	"./home/feature-gallery-lookbook.jpg": 4307,
	"./home/frame-bright-spring.jpg": 8509,
	"./home/frame-bright-winter.jpg": 1045,
	"./home/frame-dark-winter.jpg": 3969,
	"./home/frame-light-spring.jpg": 1531,
	"./home/frame-soft-summer.jpg": 6309,
	"./home/frame-warm-spring.jpg": 9624,
	"./home/hero-collage-floral.jpg": 1900,
	"./home/hero-collage-milan.jpg": 981,
	"./home/hero-collage-yellow.jpg": 8330,
	"./home/look-soft-autumn-mapped.jpg": 3160,
	"./home/look-soft-autumn.jpg": 3988,
	"./home/look-soft-summer-chips.jpg": 4191,
	"./home/look-warm-autumn-capsule.jpg": 7791,
	"./home/look-warm-autumn-park.jpg": 5218,
	"./home/palette-bright-spring.jpg": 9391,
	"./home/palette-bright-winter.jpg": 4275,
	"./home/palette-choice.jpg": 4942,
	"./home/palette-cold-summer.jpg": 6937,
	"./home/palette-cold-winter.jpg": 9481,
	"./home/palette-dark-autumn.jpg": 8202,
	"./home/palette-dark-winter.jpg": 5347,
	"./home/palette-light-spring.jpg": 5041,
	"./home/palette-light-summer.jpg": 8105,
	"./home/palette-soft-autumn.jpg": 6778,
	"./home/palette-soft-summer.jpg": 2903,
	"./home/palette-warm-autumn.jpg": 7795,
	"./home/palette-warm-spring.jpg": 7022,
	"./home/stock-colorist.jpg": 109,
	"./home/stock-studio.jpg": 6936,
	"./home/stock-stylist.jpg": 1116,
	"./img-01.png": 1628,
	"./install-en.jpg": 5364,
	"./install-ios-en.jpg": 352,
	"./install-ios-ru.jpg": 6602,
	"./install-ru.jpg": 4358,
	"./logo.png": 5842,
	"./lookbook.pdf": 3127,
	"./menu-android.jpg": 3024,
	"./menu-ios-en.jpg": 622,
	"./menu-ios.jpg": 7422,
	"./rainbow-bg.png": 9241,
	"./rainbow-folder.png": 8308,
	"./rainbow.png": 4239,
	"./rainbow.svg": 9663
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9585;